export default __webpack_public_path__ + "46af428c8b032821d102dae77f30ade4.png";